// extracted by mini-css-extract-plugin
module.exports = {"navLink":"desktop-navigation-link_navLink__Y6EmC","navLinkInner":"desktop-navigation-link_navLinkInner__VlxFg"};